import React, { useState } from "react";
import NaviLogo from "./shared/NaviLogo";
import EAIconButton from "../../app/components/shared/Buttons/EAIconButton";
import { useTranslation } from "react-i18next";
import { TbShoppingCart } from "react-icons/tb";
import { FiMenu } from "react-icons/fi";
import { FINALIZE_PAGE } from "../../app/routes";
import { useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import BasketNavButton from "./shared/BasketNavButton";
import NaviLinks from "./shared/NaviLinks";
import LanguageSelect from "../LanguageSelect";
import { useSelector } from "react-redux";
import { State } from "../../app/store";
import EADivider from "../../app/components/shared/EADivider";

const MobileNavBar: React.FC = () => {
  const basketLength = useSelector((state: State) => state.basket.basketLength);
  const navigate = useNavigate();
  const [openNavigation, setOpenNavigation] = useState(false);
  const { t } = useTranslation();

  const onBasketClick = () => {
    navigate(FINALIZE_PAGE);
  };

  const onClickMenu = () => {
    setOpenNavigation(!openNavigation);
  };

  const onCloseMenu = () => {
    setOpenNavigation(false);
  };
  return (
    <nav className="mobile-navbar" data-testid="mobile-navbar">
      <div className="mobile-navbar-head">
        <NaviLogo />
        <div className="navi-icons">
          {!openNavigation && (
            <span className="basket-anchor" data-basket-anchor>
              <EAIconButton
                title={t("koszyk")}
                onClick={() => onBasketClick()}
                icon={<TbShoppingCart />}
                variant="icon"
                badgeValue={basketLength}
              />
            </span>
          )}

          <EAIconButton
            title={t("nawigacja")}
            onClick={() => onClickMenu()}
            icon={openNavigation ? <IoClose /> : <FiMenu />}
            variant="icon"
          />
        </div>
      </div>

      {openNavigation && (
        <div className="mobile-navbar-body">
          <EADivider />
          <BasketNavButton onAdditionalAction={onCloseMenu} />
          <NaviLinks onClick={onCloseMenu} />
          <LanguageSelect isMobile />
        </div>
      )}
    </nav>
  );
};

export default MobileNavBar;
